import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaTimesCircle } from 'react-icons/fa';
import './PaymentCancel.css';

const PaymentCancel = () => {
  const navigate = useNavigate();

  // Function to navigate to pricing section
  const navigateToPricing = () => {
    navigate('/');
    setTimeout(() => {
      const pricingSection = document.getElementById('pricing');
      if (pricingSection) {
        pricingSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  return (
    <div className="payment-cancel-container">
      <div className="payment-cancel-card">
        <div className="icon-wrapper">
          <FaTimesCircle className="react-icon cancel-icon-color" />
        </div>
        <h2>Payment Cancelled</h2>
        <p>You've cancelled your subscription payment. No charges have been made to your account.</p>
        <p>You can still access the free features of our platform or try upgrading again later.</p>
        
        <div className="cancel-actions">
          <button 
            onClick={navigateToPricing}
            className="retry-button"
          >
            View Pricing Again
          </button>
          <button 
            onClick={() => navigate('/dashboard')}
            className="dashboard-button"
          >
            Go to Dashboard
          </button>
          <button 
            onClick={() => navigate('/')}
            className="home-button"
          >
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancel;